export default __webpack_public_path__ + "static/media/github.53daa6a8.png";